import { useState } from 'react'
import { fotosIaApi } from '../api/fotosIa'
import { colors, font, text } from '../design/tokens'

// "Qué está mal" en una foto hecha por la IA (Martin, 3 oct 2026). El pedido
// LLEGA siempre a Gemini (con la foto real como referencia) y queda guardado;
// que la corrección salga bien no está garantizado: la foto nueva se revisa
// igual que la primera. Cada corrección se cobra como una foto nueva.
// Lo usan el celular (/m/fotos) y la ficha del artículo.
export default function CorreccionFotoIa({ fotoId, onCorregida, disabled }) {
  const [texto, setTexto] = useState('')
  const [enviando, setEnviando] = useState(false)
  const [error, setError] = useState('')

  const corregir = async () => {
    if (!texto.trim()) { setError('Escribí qué hay que corregir.'); return }
    setEnviando(true); setError('')
    try {
      const { data } = await fotosIaApi.corregir(fotoId, texto.trim())
      setTexto('')
      onCorregida(data)
    } catch (e) {
      const errs = e.response?.data?.errors
      setError(errs ? Object.values(errs).flat().join(' ') : (e.response?.data?.message || 'No se pudo pedir la corrección.'))
    } finally { setEnviando(false) }
  }

  return (
    <div style={st.caja}>
      <label style={st.label}>¿Algo está mal? Escribilo y la IA lo corrige</label>
      <textarea
        value={texto}
        onChange={e => setTexto(e.target.value)}
        placeholder='Ej: en la etiqueta dice "GRENATING" y no existe: esa parte va borrosa, sin letras'
        rows={3}
        maxLength={600}
        style={st.textarea}
        disabled={enviando || disabled}
      />
      <button type="button" onClick={corregir} disabled={enviando || disabled || !texto.trim()} style={{ ...st.boton, opacity: enviando || disabled || !texto.trim() ? 0.5 : 1 }}>
        {enviando ? 'Corrigiendo… (unos segundos)' : '✎ Pedir corrección'}
      </button>
      <p style={st.nota}>La foto corregida se revisa igual que esta. Cada corrección se cobra como una foto nueva.</p>
      {error && <p style={{ ...st.nota, color: colors.err }}>{error}</p>}
    </div>
  )
}

const st = {
  caja: { marginTop: 12, padding: 12, borderRadius: 10, border: `1px solid ${colors.border}`, background: colors.bgSoft },
  label: { display: 'block', fontSize: text.sec, fontWeight: 600, color: colors.text, marginBottom: 6, fontFamily: font.sans },
  textarea: { width: '100%', boxSizing: 'border-box', padding: 10, borderRadius: 8, border: `1px solid ${colors.textPlh}`, fontSize: 16, fontFamily: font.sans, color: colors.text, background: colors.bg, resize: 'vertical' },
  boton: { marginTop: 8, width: '100%', padding: '12px 14px', minHeight: 44, borderRadius: 10, border: `1px solid ${colors.text}`, background: colors.bg, color: colors.text, fontSize: 15, fontWeight: 600, fontFamily: font.sans, cursor: 'pointer' },
  nota: { fontSize: text.sec, color: colors.textSec, margin: '6px 0 0', fontFamily: font.sans },
}
